export default __webpack_public_path__ + "static/enceinte6-5c934b175dea79ccb4ac4e1aaf9f4951.jpg";